import { useMemo } from 'react';
import { addMediaUrlParsingCompleted } from '@wix/bi-logger-media-data/v2';
import { bi } from '../../../services/loggers/bi';

export const useTrackAddMediaUrlParsing = () =>
  useMemo(
    () => ({
      trackAddMediaUrlParsingCompleted: (params) => bi.logger().report(addMediaUrlParsingCompleted(params)),
    }),
    [],
  );
